module.exports = __webpack_public_path__ + "img/logo-menu-branco.9782a98a.svg";